import { useContext } from 'react';
import { AppContext } from '@/context/AppContext';
import Header from '@/components/layout/Header';
import Dashboard from '@/components/dashboard/Dashboard';
import AdminPanel from '@/components/admin/AdminPanel';
import Toast from '@/components/shared/Toast';
import ScanProgress from '@/components/dashboard/ScanProgress';
import ReportTemplate from '@/components/pdf/ReportTemplate';
import "@/App.css";

export default function App() {
  const { activeView } = useContext(AppContext);

  return (
    <div className="min-h-screen bg-[#0A0F1E] text-[#E2E8F0] font-syne" data-testid="app-container">
      <Header />
      <ScanProgress />
      <main className="max-w-[1320px] mx-auto px-5 py-6">
        {activeView === 'dashboard' && <Dashboard />}
        {activeView === 'admin' && <AdminPanel />}
      </main>
      <Toast />
      <ReportTemplate />
    </div>
  );
}
